import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './auth/useAuth';
import { Layout } from './components/Layout';
import { GeneratorPage } from './pages/GeneratorPage';
import { TemplateLibraryPage } from './pages/TemplateLibraryPage';
import { TemplateEditorPage } from './pages/TemplateEditorPage';

export default function App() {
  const auth = useAuth();

  if (auth.loading) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100%' }}>
        <p className="muted">Authenticating with Okta…</p>
      </div>
    );
  }

  if (!auth.user) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100%' }}>
        <p className="muted">Redirecting to 8x8 SSO…</p>
      </div>
    );
  }

  return (
    <Layout auth={auth}>
      <Routes>
        <Route path="/" element={<Navigate to="/generate" replace />} />
        <Route path="/generate" element={<GeneratorPage auth={auth} />} />
        <Route path="/generate/:templateId" element={<GeneratorPage auth={auth} />} />
        <Route path="/templates" element={<TemplateLibraryPage auth={auth} />} />
        <Route path="/templates/new" element={<TemplateEditorPage auth={auth} mode="create" />} />
        <Route path="/templates/:id/edit" element={<TemplateEditorPage auth={auth} mode="edit" />} />
        <Route path="/callback" element={<p className="muted">Completing sign-in…</p>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function NotFound() {
  return (
    <div className="card">
      <h2>Page not found</h2>
      <p className="muted">The page you tried to visit doesn't exist.</p>
    </div>
  );
}
